import { DownOutlined } from '@ant-design/icons';
import { AvatarDropdown } from '@/components/RightContent/AvatarDropdown';
import { useModel } from '@umijs/max';
import { SelectLang as LocaleSelect } from '@@/plugin-locale';
import { Space } from 'antd';

export type SiderTheme = 'light' | 'dark';

export const HeaderActions: React.FC = () => {
  const { initialState } = useModel('@@initialState');
  const currentUser = initialState?.currentUser;
  const displayName = currentUser?.userNickname || currentUser?.username || '访客';
  return (
    <Space size={16} align="center">
      <LocaleSelect />
      <AvatarDropdown menu>
        <span
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: 6,
            color: '#4b5563',
            fontSize: 14,
            fontWeight: 500,
            cursor: 'pointer',
            padding: '6px 10px',
            borderRadius: 10,
          }}
        >
          {displayName}
          <DownOutlined style={{ fontSize: 10 }} />
        </span>
      </AvatarDropdown>
    </Space>
  );
};

export const Question: React.FC = () => {
  return null;
};
